import { render, staticRenderFns } from "./ConfirmRegisteredInfo.vue?vue&type=template&id=5542dfe2&scoped=true&"
import script from "./ConfirmRegisteredInfo.vue?vue&type=script&lang=js&"
export * from "./ConfirmRegisteredInfo.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmRegisteredInfo.vue?vue&type=style&index=0&id=5542dfe2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5542dfe2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VRow})
